// import './projectwizard-base.scss';

import React, { useState } from 'react';
import { Row, Col, Button, ButtonGroup } from 'reactstrap';

import Finish from './Finish';
import { ButonDisabled } from './ButonDisabled';
import { Translate, translate } from 'react-jhipster';

export const SelectButton = props => {
  const selectedColor = 'primary';
  const [cssColor, setCssColor] = useState(selectedColor);

  const handleClickYes = e => {
    props.handleClickYes();
    setCssColor(selectedColor);
  };
  const handleClickNo = e => {
    props.handleClickNo();
    setCssColor(selectedColor);
  };
  const handleClickBack = e => {
    props.handleClickBack();
    setCssColor(selectedColor);
  };

  const handleClickOk = e => {
    props.handleClickOk();
    setCssColor(selectedColor);
  };

  return props.finish ? (
    <div className="wizard-actions">
      <ButtonGroup className="wizard-cta-group">
        <ButonDisabled onClick={handleClickBack} disabled={!props.showBack} className="cta cta-back">
          ← {translate('entity.action.back')}
        </ButonDisabled>

        <ButonDisabled onClick={handleClickNo} disabled={!props.selectable} className="cta cta-no">
          {translate('entity.action.no')}
        </ButonDisabled>

        <ButonDisabled onClick={handleClickYes} disabled={!props.selectable} className="cta cta-yes">
          {translate('entity.action.yes')}
        </ButonDisabled>

        <ButonDisabled onClick={handleClickOk} disabled={!props.showOk} className="cta cta-ok">
          {translate('entity.action.ok')}
        </ButonDisabled>
      </ButtonGroup>
    </div>
  ) : null;
};
